import request from '@webtrader/core/request';

export interface IGeolocation {
  ipAddress: string;
  provider: string;
  country: string; // Only Support SG , MY and CN (Need to let DevOps know if there is more country to be supported)
  forwardedIP: string;
  remoteAddr: string;
}

export const geolocationApi = {
  getGeolocation: () => request.get<IGeolocation>('/api/config/v1/geo/location')
};
